import React from 'react';
import { nl2br } from '../../../utils/nl2br';

import PlusMinusIcon from '../../icons/PlusMinusIcon';
import Collapsible from 'react-collapsible';

const allAccordions = [
  {
    key: 'observations',
    label: 'Observations and Responses',
  }, {
    key: 'opportunities',
    label: 'Opportunities for Improvement and Consultative Recommendations',
  }
];

function RecentAssessments({ hasNoParts, answers, colClass }) {
  const accordions = hasNoParts
    ? allAccordions.slice(1)
    : allAccordions;
  return (
    accordions.map(accordion => (
      <Collapsible
        key={accordion.key}
        tabIndex={0}
        trigger={
          <div className="review-detail__recommendations">
            <PlusMinusIcon option="plus" />
            {accordion.label}
          </div>
        }
        triggerWhenOpen={
          <div className="review-detail__recommendations">
            <PlusMinusIcon option="minus" />
            {accordion.label}
          </div>
        }
        easing="ease-in-out"
        contentInnerClassName="text"
      >
        <div>
          {answers.map((answer, i) => (
            <div className={colClass} key={i}>
              <div className="review-detail__comments">
                {answer
                  ? nl2br(answer[accordion.key]) || <span className="unanswered">N/A</span>
                  : <span className="unanswered">N/A</span>
                }
              </div>
            </div>
          ))}
        </div>
      </Collapsible>
    ))
  );
}

export default RecentAssessments;



// WEBPACK FOOTER //
// ./src/components/features/review/ReviewAccordions.js